import { createContext } from 'react';

import { use3dModelList } from '../../../../../3d/hooks/use-3d-model-list';

export interface SelectModelDialogueContextInterface {
  use3dModelList: typeof use3dModelList;
}

let context: React.Context<SelectModelDialogueContextInterface>;

export const getSelectModelDialogueContext = () => {
  if (!context) {
    context = createContext({
      use3dModelList,
    });
  }
  return context;
};
